export default __webpack_public_path__ + "static/media/b43.f1304396.png";